exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".help-tenders-page{display:flex;flex-direction:column;height:calc(100vh - 194px);min-height:0;overflow:hidden}.help-tenders-tabs{flex:1 1 auto;min-height:0;display:flex;flex-direction:column}:host ::ng-deep .help-tenders-tabs .mat-mdc-tab-body-wrapper{flex:1 1 auto;min-height:0;overflow:hidden}:host ::ng-deep .help-tenders-tabs .mat-mdc-tab-body,:host ::ng-deep .help-tenders-tabs .mat-mdc-tab-body-content{height:100%;overflow:hidden}.help-tenders-tab-pane{padding:8px 8px 0;height:100%;display:flex;flex-direction:column}.help-content-scroll{flex:1 1 auto;min-height:0;overflow-y:auto;overflow-x:hidden;padding-right:6px}.help-content-subheading{margin-top:0;margin-bottom:10px;font-size:16px;font-weight:600;color:#111827}.help-content-body h3{margin-bottom:10px;margin-top:15px;text-decoration:underline}.help-content-body li{margin-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Client/app/views/account.management/help/help.tenders.component.css
// module id = 1179
// module chunks = 0